import * as api from "../../api";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";

import { ALERT } from "../../constants/actionTypes";

import Logo from "../../images/logo.svg";

import "./Reset.css";

const Reset = ({ match }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = match.params.token;
  const [formData, setFormData] = useState({
    repeat_password: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleReset = async (e) => {
    e.preventDefault();

    try {
      await api.resetPassword({ ...formData, token });
      history.replace("/auth/signin");
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    }
  };

  return (
    <div
      style={{ height: "100vh" }}
      className="d-flex flex-column align-center justify-center w-100 h-100 p-20"
    >
      <form className="reset__form d-flex flex-column align-center p-20">
        <img src={Logo} alt="" />
        <h1 className="text-center">Reset Password</h1>
        <span className="font-sm text-center">
          Input your need password below
        </span>
        <label className="d-flex flex-column w-100 my-10">
          <span className="font-heavy px-5 my-5">Password</span>
          <input
            className="border-1 outline-0 p-10"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
          />
        </label>
        <label className="d-flex flex-column w-100 my-10">
          <span className="font-heavy px-5 my-5">Repeat Password</span>
          <input
            className="border-1 outline-0 p-10"
            type="password"
            name="repeat_password"
            value={formData.repeat_password}
            onChange={handleChange}
          />
        </label>
        <button
          className="font-normal p-10 my-10 w-100 font-bold border-0 outline-0"
          onClick={handleReset}
        >
          Reset Password
        </button>
      </form>
    </div>
  );
};

export default Reset;
